import { IconProps } from 'shared/components/Icons/types/IconProps'
import { colors } from 'shared/lib'

export const ChevronDown = ({
  color = colors.FC2_LIGHT_GREY,
  width = '8',
  height = '5',
  className = '',
  viewBox = '0 0 8.05762 4.74902',
  ...props
}: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    {...props}
  >
    <path
      d="M8.05762 0.707031L4.37207 4.39453L4.01758 4.74902L3.66406 4.39355L0 0.706055L0.708984 0.000976562L4.01953 3.33203L7.35059 0L8.05762 0.707031Z"
      fill={color}
    />
  </svg>
)
